import { useEffect } from 'react';
import { SEO } from '../data/config';
export function Seo() {
  useEffect(() => {
    document.title = SEO.title;
    document.documentElement.lang = 'en';
    const set = (attr: 'name' | 'property', key: string, value: string) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };
    set('name', 'description', SEO.description);
    set('property', 'og:title', SEO.title);
    set('property', 'og:description', SEO.description);
    set('property', 'og:type', 'website');
    if (!document.head.querySelector('meta[name="viewport"]')) {
      set('name', 'viewport', 'width=device-width, initial-scale=1');
    }
  }, []);
  return null;
}